import { render, staticRenderFns } from "./coperUser.vue?vue&type=template&id=bef35316&scoped=true&"
import script from "./coperUser.vue?vue&type=script&lang=js&"
export * from "./coperUser.vue?vue&type=script&lang=js&"
import style0 from "./coperUser.vue?vue&type=style&index=0&id=bef35316&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bef35316",
  null
  
)

export default component.exports